import './editorial.css';

/**
 * PulledQuote — inline narrative callout for a short line worth surfacing.
 * Italic Playfair, thin --gold-brass rules + the Key-Developments-style left
 * border, floated into the column grid (two-column on desktop, stacked on mobile)
 * rather than breaking full-width.
 */
export default function PulledQuote({ children, attribution }) {
  return (
    <aside className="bi-pullquote" role="note">
      {children}
      {attribution && <span className="bi-pullquote__attr">— {attribution}</span>}
    </aside>
  );
}
